import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';
import Icon from './Icon.jsx';

// The logged-in person's OWN AI connections (Settings → Security) — personal
// keys made when they connected Claude/ChatGPT with "just my access" (flag
// integrations.api_personal). Each sees only what this person's role sees in
// Pulse. Created only through the connect flow in the AI app; listed and
// disconnected here. Owners + Howler see everyone's in the API access card
// (ApiKeysCard), which is the admin/owner side of the same feature.
export default function PersonalAiConnectionsCard() {
  const [keys, setKeys] = useState(null);
  const load = () => api.listMyPersonalKeys().then((r) => setKeys(r.keys || [])).catch(() => setKeys(null));
  useEffect(() => { load(); }, []);
  if (!keys) return null; // flag off (route gated) — keep the section quiet

  const disconnect = async (k) => {
    if (!window.confirm(`Disconnect "${k.name}"? The AI app loses access immediately.`)) return;
    try { await api.revokeMyPersonalKey(k.id); load(); }
    catch (e) { alert('Couldn’t disconnect: ' + e.message); }
  };
  const active = keys.filter((k) => !k.revokedAt);
  const base = window.location.origin;
  return (
    <div style={card}>
      <div style={{ ...title, display: 'flex', alignItems: 'center', gap: 6 }}><Icon name="owl" size={15} /> My AI connections</div>
      <p style={sub}>
        Connect Claude or ChatGPT to the Owl as <b>you</b>: add <code style={inline}>{base}/mcp</code> as a connector
        (in <a href="https://claude.ai/settings/connectors" target="_blank" rel="noreferrer" style={link}>Claude</a> or{' '}
        <a href="https://chatgpt.com/#settings/Connectors" target="_blank" rel="noreferrer" style={link}>ChatGPT</a>) and
        pick “just my access”. It only sees the dashboards and data your Pulse role sees.
      </p>
      {active.length === 0 && <p style={{ ...sub, marginBottom: 0 }}>You haven’t connected any AI apps yet.</p>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {active.map((k) => (
          <div key={k.id} style={row}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 13.5, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{k.entityName || 'Client'}</div>
              <div style={{ fontSize: 11.5, color: 'var(--muted)' }}>
                {k.name} · {k.lastUsedAt ? `last used ${new Date(k.lastUsedAt).toLocaleDateString()}` : 'never used'}
              </div>
            </div>
            <button style={dangerBtn} onClick={() => disconnect(k)}>Disconnect</button>
          </div>
        ))}
      </div>
    </div>
  );
}

const card = { background: 'var(--card)', border: '1px solid var(--hairline)', borderRadius: 12, padding: 16, marginTop: 16 };
const title = { fontSize: 14, fontWeight: 700, marginBottom: 6 };
const sub = { fontSize: 13, color: 'var(--muted)', margin: '0 0 12px' };
const inline = { fontSize: 12, background: 'var(--elevated, #f3f3f5)', borderRadius: 5, padding: '1px 5px', wordBreak: 'break-all' };
const link = { color: 'var(--brand)' };
const row = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, border: '1px solid var(--hairline)', borderRadius: 10, padding: '10px 12px' };
const dangerBtn = { border: '1px solid var(--hairline)', background: 'transparent', color: 'var(--danger, #dc2626)', borderRadius: 980, padding: '9px 16px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer', minHeight: 40, flexShrink: 0 };
